import { render, staticRenderFns } from "./menuCategory.vue?vue&type=template&id=ab978a4a&scoped=true"
import script from "./menuCategory.vue?vue&type=script&lang=js"
export * from "./menuCategory.vue?vue&type=script&lang=js"
import style0 from "./menuCategory.vue?vue&type=style&index=0&id=ab978a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab978a4a",
  null
  
)

export default component.exports